// apps/web/src/app/shell/LompatIsi.tsx
import { uiStrings } from '@satu/shared'

/**
 * "Langsung ke isi", the shell's first control (section 04): the focus goes to the content
 * (`#isi`, focusable with tabIndex -1) without a history entry of its own. A fragment link's
 * entry is not the router's (no `idx`), and the leave question needs one: a Back from the next
 * page onto it would be let through unasked (PenjagaPerubahan), unsaved changes and all.
 */
export function LompatIsi({ isiId = 'isi' }: { isiId?: string }) {
  return (
    <a
      href={`#${isiId}`}
      className="skip-link"
      onClick={(event) => {
        event.preventDefault()
        document.getElementById(isiId)?.focus()
      }}
    >
      {uiStrings.navigasi.langsungKeIsi}
    </a>
  )
}
